import { styled } from '@/stitches.config';
import { Link as RouterLink } from 'react-router-dom';

import { Sizes } from '@common/types';

const Link = styled(RouterLink, {
  $$link: '$colors$blue300',
  $$linkActive: '$colors$blue200',

  // Custom styles
  color: '$$link',
  fontWeight: '$medium',
  px: '$0',
  py: '$0',
  textDecoration: 'none',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  '&:active': {
    color: '$$linkActive',
  },

  // Variants
  variants: {
    size: {
      large: {
        fontSize: '$md',
      },
      small: {
        fontSize: '$sm',
      },
    },
  },

  defaultVariants: {
    size: Sizes.SMALL,
  },
});

export default Link;
